import React from 'react';
import { Button } from '@mui/material';
import { MoreHorizOutlined } from '@mui/icons-material';

const WorkflowSessionModalButton = ({ setWorkflowSessionModal, label, disableControl, setValueLabel }) => {
    return (
        <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
                setValueLabel(label);
                setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
        </Button>
    );
};

export default WorkflowSessionModalButton;

